import { IChartData } from '../../../../components/UI-Elements/Charts/DateValueInputMultiChart/DateValueInputMultiChart';
import { IFutureOrder, IClientExposure, ISupplierExposure } from '../../../../sp-types/FutureOrderType';
import { Product } from '../../../../sp-types/productType';
import { MonthYearValue } from '../../../../utils/MonthYear/MonthYearValue';
import { MonthYear } from '../../../../utils/MonthYear/monthYear';
import { RAW_MATERIALS_PRICE_ADJUSTMENT_DICTIONARY } from '../RawMaterialsExposure/RawMaterialsUtils';
import { Material } from '../../../../sp-types/materialType';
import moment from 'moment';

export const adjustExposureCalendar = (
  inputCalendar: MonthYearValue[],
  adjustment: string,
  offset: number,
  weightInProduct: number,
): MonthYearValue[] =>
  RAW_MATERIALS_PRICE_ADJUSTMENT_DICTIONARY[adjustment](offset, weightInProduct, inputCalendar || []);

export const calculateMaterialsClientPayment = (
  editedOrder: IFutureOrder,
  productCalendar: MonthYearValue[],
  clientExposure: Record<string, IClientExposure>,
  indexAdjustment: string,
  indexOffset: number,
  materialsMap: Record<string, Material>,
  currentProduct?: Product,
): Record<string, IClientExposure> =>
  currentProduct?.ingredients.reduce(
    (acc, { materialID, weightInProduct }) => ({
      ...acc,
      [materialID]: {
        priceIndex: clientExposure[materialID]?.priceIndex || editedOrder.clientExposure[materialID]?.priceIndex || '',
        weightInProduct,
        adjustment: indexAdjustment,
        indexOffset,
        exposureCalendar: adjustExposureCalendar(productCalendar || [], indexAdjustment, -indexOffset, weightInProduct),
      } as IClientExposure,
    }),
    {} as Record<string, IClientExposure>,
  ) || {};

export const getClientCharts = (
  materialPayment: Record<string, IClientExposure>,
  materialsMap: Record<string, Material>,
  colorsMap: Record<string, string>,
  convertionMap: Record<string, number>,
): IChartData[] =>
  Object.entries(materialPayment).map(([materialId, { exposureCalendar }]) => ({
    data: multiplyQuantityBy(exposureCalendar, -convertionMap[materialId]),
    title: materialsMap[materialId]?.name,
    materialId,
    type: 'bar',
    color: colorsMap[materialId],
  }));

export const getMaterialExposureCharts = (
  materials: ISupplierExposure[],
  materialsMap: Record<string, Material>,
  colorsMap: Record<string, string>,
): IChartData[] => mapMaterialToCharts(materials, materialsMap, colorsMap);

export const mapMaterialToCharts = (
  materials: { materialId: string; exposureCalendar: MonthYearValue[] }[],
  materialsMap: Record<string, Material>,
  colorsMap: Record<string, string>,
): IChartData[] =>
  materials.map(({ materialId, exposureCalendar }) => ({
    data: exposureCalendar,
    title: materialsMap[materialId]?.name,
    type: 'bar',
    color: colorsMap[materialId],
  }));

export const multiplyQuantityBy = (inputValues: MonthYearValue[], multiplier: number): MonthYearValue[] =>
  inputValues.map(({ date, value: quantity }) => ({ date, value: quantity * multiplier }));

const startDate = moment().add(-6, 'M');

export const getStartingDate = (): MonthYear => {
  return { month: startDate.month() + 1, year: startDate.year() };
};

export const makeNegative = (inputValues: MonthYearValue[]): MonthYearValue[] =>
  inputValues.map(({ date, value }) => ({ date, value: -value }));
